const FieldLabel = ({ htmlFor, children }) => (
  <label
    htmlFor={htmlFor}
    className="block mb-1.5 text-sm font-semibold text-gray-700 dark:text-gray-300"
  >
    {children}
  </label>
);

export default FieldLabel;
